import { IconsMap } from '@nx-frontend/shared/ui/icon';
import { ContextMenuItemType, MenuItemDefault } from '@nx-frontend/shared/types';

export const renameMenuItem: MenuItemDefault = Object.freeze({
  id: 'rename',
  title: 'Rename',
  icon: IconsMap.EDIT,
  type: ContextMenuItemType.DEFAULT,
});

export const openInAiMenuItem: MenuItemDefault = Object.freeze({
  id: 'open-in-ai',
  title: 'Open in AI Assistant',
  icon: IconsMap.MAGIC_1,
  type: ContextMenuItemType.DEFAULT,
});

export const duplicateMenuItem: MenuItemDefault = Object.freeze({
  id: 'duplicate',
  title: 'Duplicate',
  icon: IconsMap.COPY,
  type: ContextMenuItemType.DEFAULT,
});

export const openInNewTabItem: MenuItemDefault = Object.freeze({
  id: 'open-in-new-tab',
  title: 'Open in new tab',
  icon: IconsMap.OPEN,
  type: ContextMenuItemType.DEFAULT,
});

export const shareItem: MenuItemDefault = Object.freeze({
  id: 'share',
  title: 'Share',
  icon: IconsMap.ARROW_REPLY_1,
  type: ContextMenuItemType.DEFAULT,
});

export const unshareItem: MenuItemDefault = Object.freeze({
  id: 'unshare',
  title: 'Remove shared link',
  icon: IconsMap.MINUS_CIRCLE,
  type: ContextMenuItemType.DEFAULT,
});

export const copyLinkItem: MenuItemDefault = Object.freeze({
  id: 'copy-link',
  title: 'Copy link',
  icon: IconsMap.LINK_1,
  type: ContextMenuItemType.DEFAULT,
});

export const deleteItem: MenuItemDefault = Object.freeze({
  id: 'delete',
  title: 'Delete',
  icon: IconsMap.TRASH,
  type: ContextMenuItemType.DEFAULT,
});

export const manageMembersItem: MenuItemDefault = Object.freeze({
  id: 'manage-members',
  title: 'Manage members',
  icon: IconsMap.PERSONS,
  type: ContextMenuItemType.DEFAULT,
  textStyleClasses: 'font-bold text-cyan-900',
  iconStyles: '!text-cyan-900',
});

export const subfolderMenuItem: MenuItemDefault = Object.freeze({
  id: 'subfolder',
  title: 'Subfolder',
  icon: IconsMap.NEW_FOLDER,
  type: ContextMenuItemType.DEFAULT,
});

export const pageMenuItem: MenuItemDefault = Object.freeze({
  id: 'page',
  title: 'Page',
  icon: IconsMap.DOCUMENT,
  type: ContextMenuItemType.DEFAULT,
});

export const taskMenuItem: MenuItemDefault = Object.freeze({
  id: 'task',
  title: 'Task',
  icon: IconsMap.TASKS_PLUS,
  type: ContextMenuItemType.DEFAULT,
});

export const createPageWithTagItem: MenuItemDefault = Object.freeze({
  id: 'page-with-tag',
  title: 'Create new page',
  icon: IconsMap.CREATE_PAGE,
  type: ContextMenuItemType.DEFAULT,
});

export const contextItemLocMap: Record<string, string> = {
  'rename': 'sidebar.sidebar-context_menus.rename',
  'open-in-ai': 'sidebar.sidebar-context_menus.open_in_ai',
  'duplicate': 'sidebar.sidebar-context_menus.duplicate',
  'open-in-new-tab': 'sidebar.sidebar-context_menus.open_in_new_tab',
  'unshare': 'sidebar.sidebar-context_menus.unshare',
  'copy-link': 'sidebar.sidebar-context_menus.copy_link',
  'delete': 'sidebar.sidebar-context_menus.delete',
  'manage-members': 'sidebar.sidebar-context_menus.manage_members',
  'subfolder': 'sidebar.sidebar-context_menus.subfolder',
  'page': 'sidebar.sidebar-context_menus.page',
  'task': 'sidebar.sidebar-context_menus.task',
  'page-with-tag': 'sidebar.sidebar-context_menus.page_with_tag',
};
